import { createClient } from '@supabase/supabase-js';
import { config } from '../../lib/config';

export const chSupabase = createClient(config.supabaseUrl, config.supabaseAnonKey, {
  auth: {
    flowType: 'implicit',
    detectSessionInUrl: true,
    persistSession: true,
    autoRefreshToken: true,
    storageKey: 'mohit-auth',
    storage: window.localStorage,
  },
});
